
// src/components/Navbar.jsx
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "./firebase"; // Ajusta la ruta

export default function Navbar() {
    const navigate = useNavigate();

    const handleLogout = () => {
        signOut(auth)
            .then(() => {
                navigate("/login-charko");
            })
            .catch((err) => {
                console.error("Error al cerrar sesión", err);
            });
    };

    return (
        <div className="navbar bg-base-200 shadow-lg py-2">
            {/* Zona izquierda: Logo o Título */}
            <div className="flex-1">
                <Link to="/dashboard" className="btn btn-ghost normal-case">
                    <img src="/logo.png" alt="Logo" className="h-10" />
                </Link>
            </div>

            {/* Zona derecha: Menú de navegación */}
            <div className="flex-none">
                <ul className="menu menu-horizontal p-0">
                    <li>
                        <Link to="/dashboard">Conversaciones</Link>
                    </li>
                    {/* <li>
                        <Link to="/conversations-clients">Conv. Consumidor Final</Link>
                    </li> */}
                    <li>
                        <Link to="/campaigns">Campañas</Link>
                    </li>
                    {/* <li>
                        <Link to="/clients">Clientes</Link>
                    </li> */}
                    {/* <li>
                        <Link to="/pendingorders">Pedidos Pendientes</Link>
                    </li> */}
                    <li>
                        <Link to="/orders">Pedidos</Link>
                    </li>

                    <li>
                        <Link to="/pendingbillingorders">Pedidos Pendientes</Link>
                    </li>
                    <li>
                        <Link to="/new-clients">Nuevos Clientes</Link>
                    </li>
                    <li>
                        <button onClick={handleLogout}>Cerrar Sesión</button>
                    </li>
                    {/* <li tabIndex={0}>
                        <a>
                            Opciones
                            <svg
                                className="fill-current ml-1"
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                            >
                                <path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z" />
                            </svg>
                        </a>
                        <ul className="p-2 bg-base-100">
                            <li>
                                <Link to="/profile">Perfil</Link>
                            </li>
                            <li>
                                <button onClick={handleLogout}>Cerrar Sesión</button>
                            </li>
                        </ul>
                    </li> */}
                </ul>
            </div>
        </div>
    );
}
